export declare type Address = `0x${string}`;

export const isAddress = ( value:unknown ): value is Address => {
	return typeof value === "string" && value.length === 42 && value.startsWith("0x");
}
